import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { useAtom } from 'jotai'
import Grid from '@mui/material/Unstable_Grid2'
import Typography from '@mui/material/Typography'

import MunicipalityAwardSingle from '@/components/municipality-awards/single'
import { useMunicipalityAwards } from '@/hooks/api/use-municipality-award'
import { selectedMunicipalityIdAtom } from '@/state'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import MunicipalityAwardForm from '@/components/forms/municipality-award'
import { UserRole } from '@/types'
import { getUserRole } from '@/helpers'
import PermissionsGate from '@/components/permissions-gate'

function MunicipalityAwardsList() {

    const role = getUserRole()

    const [municipalityId] = useAtom(selectedMunicipalityIdAtom)

    const [create, setCreate] = useState<boolean>(false)
    
    const { status, data, error } = useMunicipalityAwards(municipalityId)

    if (status === 'pending') {
        return (
            <LoadingBox />
        )
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={`Nepovedlo se načíst získaná ocenění obce s ID ${municipalityId}`}
        />
    }

    return (
        <Grid container spacing={2.5} pb={2}>
            {data.map(award => (
                <Grid xs={12} lg={6} key={award.id}>
                    <MunicipalityAwardSingle municipalityAward={award} />
                </Grid>
            ))}
            {data.length === 0 &&
                <PermissionsGate
                    userRoles={[
                        UserRole.basic,
                        UserRole.collectionCompany,
                        UserRole.collectionPointAdmin,
                        UserRole.eokoDataAdmin,
                        UserRole.resident,
                    ]}
                >
                    <Typography variant="body1" component="p" mb={2} px={1.2} pt={1.7}>
                        Tato sekce je zatím prázdná
                    </Typography>
                </PermissionsGate>
            }
            
            {(role === UserRole.admin || role === UserRole.municipalityOfficial) &&
                <Grid xs={12} lg={6}>
                    <Box sx={{ maxWidth: 720, height: '100%' }}>
                        {create?
                            <MunicipalityAwardForm closeCallback={() => setCreate(false)}/>
                            :
                            <Box sx={theme => ({
                                border: `2px dashed ${theme.palette.customGrey.cardBorder}`,
                                borderRadius: 2.5,
                                px: 2,
                                py: 4,
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            })}>
                                <Button
                                    variant="contained"
                                    color="terciary"
                                    startIcon={<AddRoundedIcon />}
                                    onClick={() => setCreate(true)}
                                >
                                    Přidat nové ocenění
                                </Button>
                            </Box>
                        }
                    </Box>
                </Grid>
            }
        </Grid>
    )
}

export default MunicipalityAwardsList
